/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  func-names,
  no-var
*/
var fieldIsVisible = function (field, bounds, zoom) {

  if (field.children) {
    return !!field.children.filter((child) => {
      return fieldIsVisible(child, bounds, zoom);
    }).length;
  }

  const ah = field.height * zoom;
  const ay = field.getAbsolutePosition().y * zoom;

  // Only checking y axis to make sure it's on the visible page area
  if (ay + ah + bounds.height < bounds.top || ay > bounds.top + bounds.height) {
    return false;
  }

  return true;
};

module.exports = fieldIsVisible;
